/**
 * Industry Menu Scroll (Swiper-based)
 * 
 * Uses Swiper.js for horizontal scrolling menu with center-active slide.
 * Automatically highlights the centered item.
 * Only active on mobile/tablet (below 768px).
 * 
 * @author Co-Pilot, mbreiwick
 */
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default function initIndustryMenuScroll() {
    const swiperEl = document.querySelector(".gf-swiper");

    // Exit if element doesn't exist
    if (!swiperEl) {
        console.warn('Swiper element .gf-swiper not found');
        return;
    }

    // Create counter element if existing counter element does not exist
    const counterEl = swiperEl.querySelector('.swiper-counter');

    if (!counterEl) {
        const counterEl = document.createElement('div');
        counterEl.className = 'swiper-counter';
        swiperEl.parentElement.appendChild(counterEl);
    }

    let swiperInstance = null;
    const breakpoint = window.matchMedia('(max-width: 820px)');

    // Initialize or destroy swiper based on screen size
    function handleBreakpoint() {
        if (breakpoint.matches) {
            // Mobile: initialize swiper if not already initialized
            if (!swiperInstance) {
                swiperInstance = initSwiper();
            }
        } else {
            // Desktop: destroy swiper if it exists
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;

                // Remove all active classes when switching to desktop
                const slides = swiperEl.querySelectorAll('.swiper-slide');
                slides.forEach(slide => {
                    slide.classList.remove('is-center');
                    const link = slide.querySelector(':scope > span > a');
                    if (link) link.classList.remove('--active');
                });
            }
        }
    }

    function initSwiper() {
        return new Swiper(swiperEl, {
            slidesPerView: 5,
            centeredSlides: true,
            centerInsufficientSlides: false,
            loop: true,
            spaceBetween: 8,
            mousewheel: true,
            cssMode: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                // when window width is >= 300px
                300: {
                    slidesPerView: 3,
                },
                376: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                },
                // when window width is >= 425px
                426: {
                    slidesPerView: 5,
                    spaceBetween: 8,
                }
            },

            // Track active/centered slide
            on: {
                init: function () {
                    updateActiveSlide(this);
                    updateCounter(this);
                },
                slideChange: function () {
                    updateActiveSlide(this);
                    updateCounter(this);
                },
            },
        });
    }

    function updateActiveSlide(swiperInstance) {
        const slides = swiperInstance.slides;
        const activeIndex = swiperInstance.activeIndex;

        slides.forEach((slide, index) => {
            const link = slide.querySelector(':scope > span > a');

            if (index === activeIndex) {
                slide.classList.add('is-center');
                if (link) link.classList.add('--active');
            } else {
                slide.classList.remove('is-center');
                if (link) link.classList.remove('--active');
            }
        });
    }

    function updateCounter(swiperInstance) {
        // For looped swiper, use realIndex (0-based) + 1
        const current = swiperInstance.realIndex + 1;
        const total = swiperInstance.slides.length;

        counterEl.textContent = `${current} / ${total}`;
    }

    // Initial check
    handleBreakpoint();

    // Listen for viewport changes
    breakpoint.addEventListener('change', handleBreakpoint);
}